import React, { createContext, useContext, useState, useCallback } from 'react';
import { get } from '../api';

const CreditContext = createContext({
  credits: null,
  loading: false,
  error: null,
  fetchCredits: () => {},
  decrementCredits: () => {},
});

export function CreditProvider({ children }) {
  const [credits, setCredits] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCredits = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await get('/api/1/user/usage');
      setCredits(data.compress_credits);
    } catch (err) {
      console.error('Error fetching credits:', err);
      setError(err.message);
      setCredits(0);
    } finally {
      setLoading(false);
    }
  }, []);

  const decrementCredits = useCallback(() => {
    setCredits(prev => Math.max(0, (prev || 0) - 1));
  }, []);

  return (
    <CreditContext.Provider value={{ credits, loading, error, fetchCredits, decrementCredits }}>
      {children}
    </CreditContext.Provider>
  );
}

export function useCredits() {
  const context = useContext(CreditContext);
  // Don't throw an error if used outside provider - return default context instead
  return context;
} 